import type { IconData } from '@stacksjs/iconify-core'

export const speaker2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M6.463 39.752c.177 2.55 2.081 4.539 4.627 4.762C13.88 44.76 18.115 45 24 45s10.121-.24 12.91-.486c2.546-.223 4.45-2.212 4.627-4.762c.225-3.227.463-8.38.463-15.752s-.238-12.525-.463-15.752c-.177-2.55-2.081-4.539-4.627-4.762C34.12 3.24 29.885 3 24 3s-10.121.24-12.91.486c-2.546.223-4.45 2.212-4.627 4.762C6.238 11.475 6 16.628 6 24s.238 12.525.463 15.752Z\"/><path d=\"M21 12a3 3 0 1 0 6 0a3 3 0 1 0-6 0m-6 18a9 9 0 1 0 18 0a9 9 0 1 0-18 0\"/><path d=\"M21 30a3 3 0 1 0 6 0a3 3 0 1 0-6 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default speaker2
